var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBienveillance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79883 12.7867C2.79883 19.5922 8.42393 23.2188 12.5416 26.4649C13.9946 27.6104 15.3941 28.6888 16.7936 28.6888C18.1931 28.6888 19.5925 27.6104 21.0456 26.4649C25.1633 23.2188 30.7884 19.5922 30.7884 12.7867C30.7884 5.98111 23.091 1.15474 16.7936 7.69753C10.4962 1.15474 2.79883 5.98111 2.79883 12.7867Z",
    fill: "#FED14C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBienveillance);
export default __webpack_public_path__ + "static/media/bienveillance.19fa812f2a6ec91b0d0a23bc75d82c7b.svg";
export { ForwardRef as ReactComponent };